//export const GUN_PEERS = 'https://gun-manhattan.herokuapp.com/gun';

export const GUN_PEERS = 'https://gundb-relay.quran.us.kg/gun';
